import { Card } from "primereact/card";
import { RadioButton } from "primereact/radiobutton";
import { QuestionResponse } from "../models";

export default function RadioButtonResponseComponent({ response }: { response: QuestionResponse[] }) {
    return (
        <Card>
            {
                response.map((res, index) => (
                    <div key={index} className="field-radiobutton">
                        <RadioButton inputId={`rb${index}`} name="response" value={res.fieldValue} checked={!!res.fieldValue} />
                        <label htmlFor={`rb${index}`}>{res.fieldValue}</label>
                    </div>


                ))
            }
        </Card>
    )

}